import { CrudFilters, IResourceComponentsProps, useShow } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
  Modal,
  Show,
  Typography,
  Form,
  Icons,
  Col,
  Row,
  Button,
  Input,
} from "@pankod/refine-antd";
import { IAttendant } from "interfaces";
import { useState } from "react";

const { Title, Text } = Typography;

export const AttendantList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter, searchFormProps } = useTable<IAttendant>({
    initialSorter: [
      {
        field: "id",
        order: "asc",
      },
    ],
    initialPageSize: 15,
    onSearch: (params: any) => {
      const filters: CrudFilters = [];
      const { q } = params;
      filters.push(
          {
              field: 'search',
              operator: 'eq',
              value: q,
          },
      );
      return filters;
    },
  });
  const [visible, setVisible] = useState(false);
  const { queryResult, showId, setShowId } = useShow<IAttendant>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <>
      <List>
        <Form layout="vertical" {...searchFormProps}>
          <Row gutter={[20, 0]}>
            <Col span={12}>
              <Form.Item name="q">
                  <Input
                      placeholder="Nombre"
                      prefix={<Icons.SearchOutlined />}
                  />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                  <Button htmlType="submit" type="primary">
                      Buscar
                  </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table {...tableProps} rowKey="id">
          <Table.Column
            dataIndex="id"
            key="id"
            title="id"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("id", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="name"
            key="name"
            title="Nombre"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("name", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="job_position"
            key="job_position"
            title="Puesto de trabajo"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("job_position", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="email"
            key="email"
            title="Email"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("email", sorter)}
            sorter
          />
           <Table.Column
            dataIndex="phone"
            key="phone"
            title="Teléfono"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("phone", sorter)}
            sorter
          />
          <Table.Column<IAttendant>
            title="Actions"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton hideText size="small" recordItemId={record.id} />
                <ShowButton hideText size="small" recordItemId={record.id}  
                  onClick={() => {
                    setShowId(record.id);
                    setVisible(true);
                }} />
                <DeleteButton hideText size="small" recordItemId={record.id} />
              </Space>
            )}
          />
        </Table>
      </List>
      <Modal visible={visible} onCancel={() => setVisible(false)}>
        <Show isLoading={isLoading} recordItemId={showId}>
          <Title level={5}>ID</Title>
          <Text>{record?.id}</Text>
          <Title level={5}>Nombre</Title>
          <Text>{record?.name}</Text>
          <Title level={5}>Puesto de trabajo</Title>
          <Text>{record?.job_position}</Text>
          <Title level={5}>Email</Title>
          <Text>{record?.email}</Text>
          <Title level={5}>Telefono</Title>
          <Text>{record?.phone}</Text>
        </Show>
      </Modal>
    </>
  );
};
